<template>
  <div v-if="isPhone" class="mobile-links">
    <div class="applications-wrapper">
      <div class="header" />
      <div class="content">
        <img
          v-if="isGoogle"
          rel="preload"
          src="~@/assets/images/mobile-google-play-badge.svg"
          alt="Google"
          @click="openApplication"
        />
        <img
          v-else
          rel="preload"
          src="~@/assets/images/mobile-app-store-badge.svg"
          alt="Apple"
          @click="openApplication"
        />
      </div>
      <div class="footer">
        <img rel="preload" src="~@/assets/images/home-ind-scm.svg" alt="Scm" />
        <img rel="preload" src="~@/assets/images/home-ind-cms.svg" alt="Cms" />
      </div>
    </div>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
import {
  isPhone,
  isGoogle,
  isApple,
  googleAppUrl,
  // appleAppUrl,
  appleStoreUrl,
  fallbackUrl
} from "../utility/MobileDetectService";

export default {
  data() {
    return {
      timeoutId: undefined
    };
  },
  computed: {
    isPhone() {
      return isPhone();
    },
    isGoogle() {
      return isGoogle();
    },
    isApple() {
      return isApple();
    }
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  },
  methods: {
    openApplication() {
      const { isGoogle: google, isApple: apple } = this;
      const url = google ? googleAppUrl() : apple ? appleStoreUrl() : fallbackUrl();

      this.openAppUrl(url);

      // When app is fixed, the process to open it will be:
      // try to open appUrl, if it fails, try to open storeUrl. This behavior  is only
      // valid for apple. With android just open intent.
      // if (apple) {
      // this.openAppUrl(appleAppUrl());
      // this.timeoutId = setTimeout(() => {
      // this.openAppUrl(appleStoreUrl());
      // }, 2000);
      // }
    },
    openAppUrl(url) {
      if (url) {
        window.location.replace(url);
      }
    }
  }
};
</script>
<style lang="scss">
.mobile-links {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url("~@/assets/images/blur_background.jpg");
  background-size: cover;
  align-items: center;
  justify-content: center;

  > .applications-wrapper {
    position: relative;
    border: 1px solid #979797;
    border-radius: 4px 4px 5px 5px;
    background-color: #ffffff;
    padding: 15px;
    display: flex;
    flex-direction: column;
    min-width: 25rem;
    max-width: 40rem;
    min-height: 25rem;
    margin: 1rem;

    > .header {
      background: url("~@/assets/images/logo_scmgroup.svg");
      background-size: auto 100%;
      background-repeat: no-repeat;
      height: 5rem;
    }

    > .content {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 1rem 0;

      > img {
        margin: 1rem;
        flex: 1;
      }
    }

    > .footer {
      height: 5rem;
      display: flex;
      align-items: center;

      > img {
        flex: 1;
        margin: 0 0.4rem 0 0;
        object-fit: cover;
      }
    }

    @media (max-aspect-ratio: 1/1) and (max-width: 280px) {
      > .footer {
        height: 7rem;
        flex-direction: column;

        > img {
          margin: 0 0 0.4rem 0;
        }
      }
    }
  }
}
</style>
